module.exports = __webpack_public_path__ + "media/newstyle/images/new-icon-twitter-5a4950d570ff6e6d7d808d35d9d6f29a.svg";